import { lazy } from "react";

export const IndustryInsightsFeed = lazy(() => import("./IndustryInsightsFeed"));
